import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Pharmacy } from 'vidis-common';
import {
  CountPrescriptionResult,
  DeletePrescriptionRequest,
  EditPrescriptionRequest,
  Prescription,
  PrescriptionFilter,
  PrescriptionPagination,
  PrescriptionReservationRequest,
  PrescriptionResult,
  VisibilityPrescriber
} from 'vidis-common/prescription';

export const PrescriptionsApiActions = createActionGroup({
  source: 'PRESCRIPTIONS API',
  events: {
    'fetch prescriptions by page': emptyProps(),
    'fetch count': emptyProps(),
    'fetch single prescription': props<{ ridCode: string }>(),
    'edit prescription': props<{ editPrescriptionRequest: Omit<EditPrescriptionRequest, 'ssin'>, pharmacy?: Pharmacy, closeDialog?: () => void }>(),
    'make reservation': props<{ ridCode: string, reservationRequest: PrescriptionReservationRequest, pharmacy: Pharmacy, closeDialog?: () => void }>(),
    'cancel reservation': props<{ ridCode: string }>(),
    'delete prescription': props<{ deletePrescriptionRequest: DeletePrescriptionRequest, closeDialog?: () => void }>(),
  }
});

export const PrescriptionsStoreActions = createActionGroup({
  source: 'PRESCRIPTIONS STORE',
  events: {
    'set prescriptions': props<{ prescriptionResult: PrescriptionResult }>(),
    'set prescriptions count': props<{ countPrescriptionResult: CountPrescriptionResult }>(),
    'set single prescription': props<{ prescription: Prescription }>(),
    'update prescription': props<{ ridCode: string, reservationPharmacy?: Pharmacy, visibilityPrescriber?: VisibilityPrescriber, visibilityPharmacy?: { pharmacy?: Pharmacy; locked: boolean; } }>(),
    'update pagination': props<{ pagination: PrescriptionPagination }>(),
    'update filtering': props<{ filters: PrescriptionFilter }>(),
    'remove one filter': props<{ key: string }>(),
    'remove reservation': props<{ ridCode: string }>(),
    'clear prescriptions': emptyProps()
  }
});

export const PrescriptionsErrorsAction = createActionGroup({
  source: 'PRESCRIPTIONS ERROR',
  events: {
    'display error toaster': props<{ errorMessage: string }>()
  }
});
